import { useCallback, useEffect, useState } from 'react';
import { listScopes } from '../../extensions/bundled/documents/documentsScopes';
import { useDocumentsUiStore, subscribeDocumentChanges } from '../../extensions/bundled/documents/documentsUiStore';
import { useAuthStore } from '../../store/authStore';

/**
 * The user's document workspaces (docscope records) in picker order, re-read on
 * every tree bump (each workspace write bumps it) and when a live sync batch
 * carries a docscope row. `[]` while `enabled` is off (the `documents.scopes`
 * flag) — the sidebar then behaves exactly as before workspaces.
 */
export default function useWorkspaces(enabled) {
  const [workspaces, setWorkspaces] = useState([]);
  const treeVersion = useDocumentsUiStore((s) => s.treeVersion);
  // Signing in or out swaps the personal bucket, and with it the list.
  const userId = useAuthStore((s) => s.user?.id ?? null);

  const reload = useCallback(async () => {
    if (!enabled) {
      setWorkspaces([]);
      return [];
    }
    try {
      const list = await listScopes();
      setWorkspaces(list);
      return list;
    } catch {
      return [];
    }
  }, [enabled]);

  useEffect(() => {
    reload();
  }, [reload, treeVersion, userId]);

  useEffect(() => {
    if (!enabled) return undefined;
    return subscribeDocumentChanges((_scopeKey, records) => {
      if ((records || []).some((r) => r.record_type === 'docscope')) reload();
    });
  }, [enabled, reload]);

  return { workspaces, reload };
}
